@let archiveToBeDeleted = archiveToBeDeletedSg();
@let isSubmitting =
  archiveEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
<atn-ds-page>
  <atn-ds-page-header [name]="'Archive'">
    <atn-summit-archive-tools actions />
  </atn-ds-page-header>
  <div class="atn-summit-archive">
    <div class="atn-summit-archive__body">
      <div class="atn-summit-archive__catalog">
        <atn-summit-archive-catalog />
      </div>
      <div class="atn-summit-archive__detail">
        <atn-summit-archive-detail />
      </div>
    </div>
  </div>
</atn-ds-page>

@if (archiveToBeDeleted) {
  @let title =
    'Are you sure you want to delete "' + archiveToBeDeleted.name + '"?';
  @let description =
    'This action cannot be undone. This will permanently delete the note.';
  <atn-ds-confirmation-overlay
    [title]="title"
    [description]="description"
    [loading]="isSubmitting"
    (cancel)="
      archiveEc.plugins.editingPlugin.feature.actions.discard
        .from('Summit.Active.Catalog.Item.Delete.Canceled')
        .dispatch({ delete: true, skipUnset: true })
    "
    (confirm)="
      archiveEc.plugins.editingPlugin.feature.actions.submit
        .from('Summit.Active.Catalog.Item.Delete.Confirmed')
        .dispatch({ delete: true })
    "
  />
}
<atn-summit-archive-configurator />
